"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultFeeAPI = void 0;
const __1 = require("..");
const oracle_1 = require("./oracle");
const big_js_1 = __importDefault(require("big.js"));
class DefaultFeeAPI {
    constructor(api) {
        this.api = api;
        this.oracleAPI = new oracle_1.DefaultOracleAPI(api);
    }
    getGriefingCollateral(amount, griefingCollateralRate) {
        return __awaiter(this, void 0, void 0, function* () {
            const dotAmount = yield this.oracleAPI.convertBitcoinToDot(amount);
            return dotAmount.mul(griefingCollateralRate);
        });
    }
    getIssueGriefingCollateralRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const griefingCollateralRate = yield this.api.query.fee.issueGriefingCollateral.at(head);
            return new big_js_1.default(__1.decodeFixedPointType(griefingCollateralRate));
        });
    }
    getReplaceGriefingCollateralRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const griefingCollateralRate = yield this.api.query.fee.replaceGriefingCollateral.at(head);
            return new big_js_1.default(__1.decodeFixedPointType(griefingCollateralRate));
        });
    }
    calculateAPY(feesPolkaBTC, feesDOT, lockedDOT, dotToBtcRate) {
        return __awaiter(this, void 0, void 0, function* () {
            if (dotToBtcRate === undefined) {
                dotToBtcRate = yield this.oracleAPI.getExchangeRate();
            }
            const feesPolkaBTCInDot = feesPolkaBTC.mul(dotToBtcRate);
            const totalFees = feesDOT.add(feesPolkaBTCInDot);
            // convert to percent
            return totalFees.div(lockedDOT).mul(100).toString();
        });
    }
}
exports.DefaultFeeAPI = DefaultFeeAPI;
//# sourceMappingURL=fee.js.map